import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  AddBoundaryFillContainer, type AddBoundaryFillContainerProps,
} from './addBoundaryFillContainer.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryAddFill: AddBoundaryFillContainerProps;
  }
}
modalRenderer.register('BoundaryAddFill', AddBoundaryFillContainer);
